function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "_004-trash-bin",
  "data-name": "004-trash-bin",
  transform: "translate(-2 -2)"
}, React.createElement("path", {
  id: "Path_19147",
  "data-name": "Path 19147",
  d: "M18.129,5H2.849a.849.849,0,1,0,0,1.7h1.7V16.884a2.547,2.547,0,0,0,2.547,2.547h6.791a2.547,2.547,0,0,0,2.547-2.547V6.7h1.7a.849.849,0,0,0,0-1.7ZM9.64,14.338a.849.849,0,1,1-1.7,0V10.093a.849.849,0,1,1,1.7,0Zm3.4,0a.849.849,0,1,1-1.7,0V10.093a.849.849,0,1,1,1.7,0Z",
  transform: "translate(0 -0.453)"
}), React.createElement("path", {
  id: "Path_19148",
  "data-name": "Path 19148",
  d: "M9.849,3.7h3.4a.849.849,0,1,0,0-1.7h-3.4a.849.849,0,1,0,0,1.7Z",
  transform: "translate(-1.058)"
}));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16.978,
    height: 16.978,
    viewBox: "0 0 16.978 16.978",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trash.bb16759b.svg";
export { ForwardRef as ReactComponent };